import { configureStore } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';
import gameStoreReducer, { GameEngineStore } from './gameStore';
import userStoreReducer, { UserStore } from './userStore';

export interface AppStore {
  gameStore: GameEngineStore;
  userStore: UserStore;
}

export const Store = configureStore<AppStore>({
  reducer: {
    gameStore: gameStoreReducer,
    userStore: userStoreReducer,
  },
  middleware: [thunkMiddleware],
});

(window as any).store = Store;
